module.exports = __webpack_public_path__ + "static/media/title_board_c.5111bc5a.svg";